import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import NavHeader from '@/components/layout/header';
import Footer from '@/components/layout/footer';
import ContactUs from '@/components/contact-us/contact-us.vue';
import { useRoute } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const route = useRoute();
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(NavHeader)), (_openBlock(), _createBlock(_component_router_view, {
        key: _unref(route).fullPath
      })), _createVNode(_unref(Footer)), _createVNode(ContactUs)], 64);
    };
  }
});